(function () {
    'use strict';

    angular
        .module('invoices')
        .controller('InvoicesFormController', InvoicesFormController);

    InvoicesFormController.$inject = ['API_BASE', '$filter', '$state', '$uibModal', '$stateParams', '$sce', '$scope', 'InvoicesService', 'SellerService', 'CompaniesService', 'FindClientsService', 'CurrencyService', 'CountriesNewService'];

    function InvoicesFormController(API_BASE, $filter, $state, $uibModal, $stateParams, $sce, $scope, InvoicesService, SellerService, CompaniesService, FindClientsService, CurrencyService, CountriesNewService) {
        var vm = this;

        vm.invoice_type = $state.current.data.invoice_type;

        vm.base_url                 = base_url;

        vm.sellers                  = [];
        vm.as_sellers               = [];
        vm.companies                = [];
        vm.items_types              = [
            {id : 'miscelaneous', name : 'Miscellaneous'},
            {id : 'open_house', name : 'Platform Rental'},
            {id : 'marketing_campaing', name : 'Marketing Campaign'},
            {id : 'webinar', name : 'Webinar'},
            {id : 'annual_plan', name : 'Annual Plan'},
            {id : 'sponsor', name : 'Sponsorship'},
            {id : 'email_blast', name : 'Email Blast'},
            {id : 'private_physical_event', name : 'Organizer paying for multiple exhibitors'},
        ];

        vm.loadSellers              = loadSellers;
        vm.loadCompanies            = loadCompanies;
        vm.getCompany               = getCompany;

        vm.getInvoiceItems          = getInvoiceItems;
        vm.setInvoiceDate           = setInvoiceDate;
        vm.setInvoiceDueDate        = setInvoiceDueDate;
        vm.getUserAddress           = getUserAddress;
        vm.setInvoiceId             = setInvoiceId;
        vm.setItemType              = setItemType;

        vm.getMyErrorValue          = getMyErrorValue;
        vm.getMyFocusMeValue        = getMyFocusMeValue;

        vm.openEditAddressModal     = openEditAddressModal;

        vm.initItems                = initItems;
        vm.changeItemStatus         = changeItemStatus;
        vm.addItem                  = addItem;

        vm.mis_description;
        vm.mis_rate;
        vm.mis_discount;
        vm.mis_redeemed_item;
        vm.mis_item_type            = {id : 'miscelaneous', name : 'Miscellaneous'};

        vm.creditRate               = 0;
        vm.originalCreditRate       = 0;
        vm.checkCredit              = checkCredit;

        vm.updateSubtotal           = updateSubtotal;
        vm.updateTotal              = updateTotal;
        vm.setDiscounts             = setDiscounts;

        vm.updateItemsRates         = updateItemsRates;

        vm.currencies               = [];
        vm.currency                 = 'USD';
        vm.loadCurrencies           = loadCurrencies;

        vm.countries                = [];
        vm.loadCountries            = loadCountries;

        vm.vatTax                   = 23;

        vm.goToConfirmationPage     = goToConfirmationPage;

        vm.findInvoiceSource        = findInvoiceSource;

        vm.setCountry               = setCountry;
        vm.getExchangeRate          = getExchangeRate;
        // Form Inputs
        vm.user                     = [];
        vm.fppCompany               = [];
        vm.companySelected          = [];
        vm.subtotal                 = 0;
        vm.total                    = 0;
        vm.discount                 = 0;
        vm.discountPlan             = 0;
        vm.discountWebinar          = 0;
        vm.discountEmailBlast       = 0;
        vm.includeTax               = 0;
        vm.customerVAT;
        vm.customerPONumber;
        vm.customerTaxId;
        vm.customerLegalName;
        vm.customerCountry;
        vm.totalVat                 = 0;
        vm.showDiscountPlan         = false;
        vm.showDiscountWebinar      = false;
        vm.showDiscountEmailBlast   = false;
        vm.invoiceDate;
        vm.dueDate;
        vm.notes;
        vm.invoiceCurrency          = [];
        vm.exchangeRate             = 1;
        vm.nonCommissionable        = 0;
        vm.sentTo;
        vm.control_id;
        vm.invoiceSource;
        vm.invoiceSourceData        = {};           

        vm.formErrors               = [];        
        vm.focusMe                  = [];
        vm.validForm                = true;

        vm.numberFormat = /^\d*(\.\d+)?$/;

        vm.optionsDatepicker = {
            format: "longDate",
            autoUpdateInput: true,
            singleDatePicker: true,
            showDropdowns: true
        };

        vm.freeEvents = [];

        vm.freeEventCheck = freeEventCheck;
        activate();


        function activate() {
            // Check if InvoicesService.data is not empty
            if (InvoicesService.data) {

                vm.control_id               = InvoicesService.data.control_id;
                vm.user                     = InvoicesService.data.user;
                vm.fppCompany               = InvoicesService.data.fppCompany;
                vm.companySelected          = InvoicesService.data.companySelected;
                vm.subtotal                 = InvoicesService.data.subtotal;
                vm.total                    = InvoicesService.data.total;
                vm.discount                 = InvoicesService.data.discount;
                vm.discountPlan             = InvoicesService.data.discountPlan;
                vm.discountWebinar          = InvoicesService.data.discountWebinar;
                vm.discountEmailBlast       = InvoicesService.data.discountEmailBlast;
                vm.creditRate               = InvoicesService.data.creditRate;
                vm.originalCreditRate       = InvoicesService.data.originalCreditRate;
                vm.includeTax               = InvoicesService.data.includeTax;
                vm.customerVAT              = InvoicesService.data.customerVAT;
                vm.customerPONumber         = InvoicesService.data.customerPONumber;
                vm.customerTaxId            = InvoicesService.data.customerTaxId;
                vm.customerLegalName        = InvoicesService.data.customerLegalName;
                vm.customerCountry          = InvoicesService.data.customerCountry;
                vm.vatTax                   = InvoicesService.data.vatTax;
                vm.totalVat                 = InvoicesService.data.totalVat;
                vm.showDiscountPlan         = InvoicesService.data.showDiscountPlan;
                vm.showDiscountWebinar      = InvoicesService.data.showDiscountWebinar;
                vm.showDiscountEmailBlast   = InvoicesService.data.showDiscountEmailBlast;
                vm.invoiceDate              = InvoicesService.data.invoiceDate;
                vm.dueDate                  = InvoicesService.data.dueDate;
                vm.notes                    = InvoicesService.data.notes;
                vm.invoiceCurrency          = InvoicesService.data.invoiceCurrency;
                vm.currency                 = InvoicesService.data.invoiceCurrency.code;
                vm.exchangeRate             = InvoicesService.data.exchangeRate;
                vm.nonCommissionable        = InvoicesService.data.nonCommissionable;
                vm.sentTo                   = InvoicesService.data.sentTo;
                vm.sellerSelected           = InvoicesService.data.sellerSelected;
                vm.redeemed_item            = InvoicesService.data.redeemed_item;
                vm.blacklist                = vm.user['exhibitor'].blacklist;
                vm.invoiceSource            = InvoicesService.data.invoiceSource;
            } else {
                if ($stateParams.hasOwnProperty('id')) {
                    if ($stateParams.hasOwnProperty('currency')) {
                        vm.currency = $stateParams.currency;
                    }
                    vm.getInvoiceItems($stateParams.id, vm.currency);
                }
                vm.setInvoiceId();
            }

            vm.loadSellers();
            vm.loadCompanies();
            vm.loadCurrencies();
            vm.loadCountries();
            vm.setInvoiceDueDate()
            vm.setInvoiceDate();
        }


        function getExchangeRate() {

            var query = {};
            query['to']   = vm.invoiceCurrency.code;
            query['from'] = vm.currency;

            query['date'] = moment().format('YYYY-MM-DD');
            CurrencyService.getExchangeRate(query).then(function(response) {
                vm.exchangeRate = parseFloat(response.data).toFixed(2);
                vm.exchangeRate = vm.exchangeRate * 1.03;
                vm.updateItemsRates();
            }).catch(function(err) {
            });
        }

        function getInvoiceItems(user_id, currency) {
            var query = {};

            if ($stateParams.hasOwnProperty('expo_id')) {
                query[vm.invoice_type + '_id'] = $stateParams.expo_id;
            }

            if ($stateParams.hasOwnProperty('semester')) {
                query['semester'] = $stateParams.semester;
            }

            query['currency'] = currency;

            InvoicesService.getInvoiceItems(user_id, currency, query, vm.invoice_type).then(function(response) {
                vm.user = response.data;

                vm.blacklist = vm.user['exhibitor'].blacklist;

                if (vm.user['exhibitor'].seller_id) {
                    vm.sellerSelected = {
                        id: vm.user['exhibitor'].seller_id,
                        name: vm.user['exhibitor'].seller_name
                    };
                }

                vm.customerLegalName = vm.user['exhibitor'].name;

                vm.sentTo = vm.user['exhibitor'].email;

                if (vm.user['credit_rate']) {
                    vm.originalCreditRate = vm.user['credit_rate'];
                }

                vm.totalFreeItems = parseInt(vm.user['exhibitor']['total_events_free']);

                vm.setCountry();

                vm.initItems();
                //vm.getUserAddress();
                vm.updateSubtotal();

            }).catch(function(err) {
            });
        }

        function loadSellers() {
            if ((vm.invoice_type == 'expo') || (vm.invoice_type == 'general')) {
                SellerService.getAll().then(function(response) {
                    vm.sellers = response.data;
                }).catch(function(err) {
                });
            } else {
                SellerService.getAllVirtualFair().then(function(response) {
                    vm.sellers = response.data;
                }).catch(function(err) {
                });
            }

            SellerService.getByType('seller_plan').then(function(response) {
                vm.as_sellers['edufindme_plan'] = response.data;
            }).catch(function(err) {
            });

            SellerService.getByType('seller_webinar').then(function(response) {
                vm.as_sellers['webinar'] = response.data;
            }).catch(function(err) {
            });

            SellerService.getByType('seller_email_blast').then(function(response) {
                vm.as_sellers['email_blast'] = response.data;
            }).catch(function(err) {
            });
        }

        function loadCompanies() {
            CompaniesService.getAllForSelect().then(function(response) {
                vm.companies = response.data;

                if (vm.companySelected.length == 0) {
                    vm.companySelected = vm.companies[0];
                }

                vm.getCompany();
            }).catch(function(err) {
            });
        }

        function loadCurrencies() {
            CurrencyService.getCurrencies().then(function(response){
                vm.currencies = response.data;
                vm.invoiceCurrency = $filter('filter')(vm.currencies, {code: vm.currency})[0];
            });
        }

        function loadCountries() {
            CountriesNewService.getCountries().then(function(response){
                vm.countries = response.data;
            });
        }

        function setCountry() {
            vm.customerCountry = $filter('filter')(vm.countries, {id: vm.user['exhibitor'].country_id})[0];
        }

        function setInvoiceDate() {
            vm.invoiceDate = new Date();
        }

        function setInvoiceDueDate() {
            var d = new Date();
            d.setDate(d.getDate() + 15);
            vm.dueDate =  d;
        }

        function getCompany() {
            vm.query = {};

            vm.query['fpp_company'] = vm.companySelected.id;

            CompaniesService.getByFilter(vm.query).then(function(response) {
                vm.fppCompany.name = response.data.name;
                vm.fppCompany.address = $sce.trustAsHtml(response.data.address);
            }).catch(function(err) {
            });
        }

        function openEditAddressModal() {

            $uibModal.open({
                templateUrl: 'templates/invoices/form/editAddress/editAddress.html',
                controller: 'EditAddressController',
                controllerAs:'editAddress',
                resolve:
                {
                    user : function () {
                        return vm.user;
                    },
                }
            });

        }

        function getUserAddress() {
            FindClientsService.getAddresses(vm.user['exhibitor'].user_id).then(function(response) {

                vm.addresses = response.data;

                if (vm.addresses.length > 0) {
                    vm.addressSelected = vm.addresses[0];

                    vm.user.address = vm.addresses[0].address + '<br>' +
                        vm.addresses[0].city_name + ', ' +
                        vm.addresses[0].region_name + ' ' +
                        vm.addresses[0].zip_code + '<br>' +
                        vm.addresses[0].country_name;
                    vm.user.addressHTML =   $sce.trustAsHtml(vm.user.address);

                    if (vm.addresses[0].country_id) {
                        vm.setCountry();
                    }
                }

            }).catch(function(err) {
            });
        }

        function setInvoiceId() {
            var d = new Date();
            vm.control_id = $filter('date')(d, 'yyyyMMddHHmmss');

            if (parseInt(vm.control_id) >= parseInt('20210120000000') && parseInt(vm.control_id) <= parseInt('20210228235959')) {
                vm.vatTax = '21';
            }
        }

        function setItemType(item) {
            item.type = vm.mis_item_type.id;
            item.type_name = vm.mis_item_type.name;
        }

        function initItems() {
            // Expos
            if (vm.user['expos']) {
                angular.forEach(vm.user['expos'], function (expo) {
                    angular.forEach(expo['items'], function (item) {
                        item.classIcon = 'fa-trash-o';
                        item.classColor = 'danger';
                        item.removed = false;
                        item.originalRate = item.rate;
                        item.item_id = (item.expo_booth_id ? item.expo_booth_id : item.item_id);
                        item.virtual_fair_id = null;
                        item.seller_id = null;
                        item.redeemed_item = null;
                    });
                });
            }

            // Virtual Fairs
            if (vm.user['virtual_fairs']) {
                angular.forEach(vm.user['virtual_fairs']['items'], function (item) {
                    item.classIcon = 'fa-trash-o';
                    item.classColor = 'danger';
                    item.removed = false;
                    item.originalRate = item.rate;
                    item.item_id = null;
                    item.expo_id = null;
                    item.seller_id = null;
                    item.pay_commission_seller = 1;
                    item.pay_commission_seller_admin = 1;
                    item.redeemed_item = null;
                });
            }

            // Additional Services
            if (vm.user['additional_services']) {
                angular.forEach(vm.user['additional_services']['items'], function (as) {
                    as.classIcon = 'fa-plus';
                    as.classColor = '';
                    as.removed = true;
                    as.originalRate = as.rate;
                    as.virtual_fair_id = null;
                    as.expo_id = null;
                    as.expo_location_id = null;
                    as.expo_booth_id = null;
                    as.seller = null;
                    as.redeemed_item = null;

                    if (as.seller_id) {
                        if (as.type == 'edufindme_plan') {
                            as.seller = $filter('filter')(vm.as_sellers['edufindme_plan'], {id: as.seller_id})[0];
                        }

                        if (as.type == 'webinar') {
                            var s = $filter('filter')(vm.as_sellers['webinar'], {id: as.seller_id});
                            if (s) {
                                as.seller = s[0];
                            }
                        }

                        if (as.type == 'email_blast') {
                            as.seller = $filter('filter')(vm.as_sellers['email_blast'], {id: as.seller_id})[0];
                        }
                    }
                });
            }

            // General
            vm.user['general'] = {
                'items' : []
            };
        }

        function changeItemStatus(item) {

            if (item.removed === false) { // Remove item
                item.classIcon = 'fa-plus';
                item.classColor = '';
                item.classText = '';
                item.removed = true;

                if (item.type == 'edufindme_plan') {
                    vm.showDiscountPlan = false;
                    vm.discountPlan = 0;
                }

                if (item.type == 'webinar') {
                    vm.showDiscountWebinar = false;
                    vm.discountWebinar = 0;
                }

                if (item.type == 'email_blast') {
                    vm.showDiscountEmailBlast = false;
                    vm.discountEmailBlast = 0;
                }
            } else { // Add item
                item.classIcon = 'fa-trash-o';
                item.classColor = 'danger';
                item.classText = 'removed-item';
                item.removed = false;

                if (item.type == 'edufindme_plan') {
                    vm.showDiscountPlan = true;
                }

                if (item.type == 'webinar') {
                    vm.showDiscountWebinar = true;
                }

                if (item.type == 'email_blast') {
                    vm.showDiscountEmailBlast = true;
                }
            }

            vm.updateSubtotal();

        }

        function addItem(fair) {
            var new_item;
            var items = fair['items'];
            var expo_id = null;
            var virtual_fair_id = null;

            if (vm.invoice_type == 'expo') {
                vm.mis_description = vm.mis_description[fair.id];
                vm.mis_rate = vm.mis_rate[fair.id].replace(',', '.');
                expo_id = fair.id;

                if (vm.mis_redeemed_item && vm.mis_redeemed_item[fair.id]) {
                    vm.mis_redeemed_item = vm.mis_redeemed_item[fair.id];
                }
            }

            vm.mis_rate = vm.mis_rate.replace(',', '.');

            if ((vm.mis_description) && (vm.mis_rate)) {

                let pay_commission_seller = 1;
                if (vm.mis_item_type.id == 'miscelaneous') {
                    pay_commission_seller = 0;
                }

                if (vm.mis_discount == undefined || vm.mis_discount == "") {
                    vm.mis_discount = 0;
                }

                new_item = {
                    classIcon: 'fa-trash-o',
                    classColor: 'danger',
                    expo_id: expo_id,
                    description: vm.mis_description,
                    rate: vm.mis_rate,
                    discount: vm.mis_discount,
                    originalRate: vm.mis_rate,
                    removed: false,
                    expo_location_id: null,
                    expo_booth_id: null,
                    seller_id: null,
                    virtual_fair_id: null,
                    pay_commission_seller_admin: 0,
                    pay_commission_seller: pay_commission_seller,
                    item_id: null,
                    seller_id: null,
                    type: vm.mis_item_type.id,
                    type_name: vm.mis_item_type.name,
                    redeemed_item: vm.mis_redeemed_item
                };

                items.push(new_item);

                vm.mis_description = '';
                vm.mis_rate = '';
                vm.mis_discount = '';

                vm.updateSubtotal();
            }
        }

        function updateSubtotal() {
            var subtotal = 0;
            var discount = 0;

            if (vm.user['expos']) {
                angular.forEach(vm.user['expos'], function (expo) {
                    angular.forEach(expo['items'], function (item) {
                        if (item.discount == undefined) {
                            item.discount = 0
                        }
                        if (item.removed === false) {
                            subtotal = parseFloat(subtotal) + parseFloat(item.rate);
                            discount = parseFloat(discount) + parseFloat(item.discount);
                        }
                    });
                });
            }

            if (vm.user['virtual_fairs']) {
                angular.forEach(vm.user['virtual_fairs']['items'], function (item) {
                    if (item.discount == undefined) {
                        item.discount = 0
                    }
                    if (item.removed === false) {
                        subtotal = parseFloat(subtotal) + parseFloat(item.rate);
                        discount = parseFloat(discount) + parseFloat(item.discount);
                    }
                });
            }

            if (vm.user['general']) {
                angular.forEach(vm.user['general']['items'], function (item) {
                    if (item.discount == undefined) {
                        item.discount = 0
                    }
                    if (item.removed === false) {
                        subtotal = parseFloat(subtotal) + parseFloat(item.rate);
                        discount = parseFloat(discount) + parseFloat(item.discount);
                    }
                });
            }

            if (vm.user['additional_services']) {
                angular.forEach(vm.user['additional_services']['items'], function (as) {
                    if (as.discount == undefined) {
                        as.discount = 0
                    }
                    if (as.removed === false) {
                        subtotal = parseFloat(subtotal) + parseFloat(as.rate);
                        discount = parseFloat(discount) + parseFloat(item.discount);
                    }
                });
            }

            vm.subtotal = subtotal;
            vm.discount = discount;

            vm.updateTotal();
        }

        function updateTotal() {

            vm.total =
                parseFloat(vm.subtotal) -
                parseFloat(vm.discount) -
                parseFloat(vm.discountPlan) -
                parseFloat(vm.discountWebinar) -
                parseFloat(vm.discountEmailBlast);

            if ((vm.creditRate > 0)  && vm.checkCredit()) {
                vm.total = vm.total - parseFloat(vm.creditRate);
            }

            if (vm.includeTax == 1){
                vm.totalVat = parseFloat((parseFloat(vm.total) * parseFloat(vm.vatTax))/100).toFixed(2);
                vm.total = parseFloat(vm.total) + parseFloat(vm.totalVat);
            }
        }

        function updateItemsRates() {
            if (vm.exchangeRate == '') {
                vm.exchangeRate = 1;
            }

            // vm.exchangeRate = vm.exchangeRate.replace(',', '.');

            if (vm.user['expos']) {
                angular.forEach(vm.user['expos'], function (expo) {
                    angular.forEach(expo['items'], function (item) {
                        item.rate = item.originalRate * vm.exchangeRate;
                    });
                });
            }

            if (vm.user['virtual_fairs']) {
                angular.forEach(vm.user['virtual_fairs']['items'], function (item) {
                    item.rate = item.originalRate * vm.exchangeRate;
                });
            }

            if (vm.user['general']) {
                angular.forEach(vm.user['general']['items'], function (item) {
                    item.rate = item.originalRate * vm.exchangeRate;
                });
            }

            vm.creditRate = vm.creditRate * vm.exchangeRate;
            vm.originalCreditRate = vm.originalCreditRate * vm.exchangeRate;

            angular.forEach(vm.user['additional_services']['items'], function (as) {
                as.rate = as.originalRate * vm.exchangeRate;
            });

            vm.updateSubtotal();
        }

        function goToConfirmationPage() {
            var seller_selected_id = null;
            if (vm.sellerSelected) {
                seller_selected_id = vm.sellerSelected.id;
            }

            var customer_country_selected = null;
            if (vm.customerCountry) {
                customer_country_selected = vm.customerCountry.id;
            }

            var fields = {
                control_id                  : vm.control_id,
                customer_id                 : vm.user['exhibitor'].user_id,
                seller_id                   : seller_selected_id,
                fpp_company                 : vm.companySelected.id,
                customer_type               : vm.user['exhibitor'].customer_type,
                customer_vat                : vm.customerVAT,
                customer_country_id         : customer_country_selected,
                total_rate                  : vm.total,
                non_commissionable          : vm.nonCommissionable,
                customer_legal_name         : vm.customerLegalName,
                contact_name                : vm.user['exhibitor'].contact_name,
                contact_email               : vm.user['exhibitor'].email,
                sent_to                     : vm.sentTo,
                due_date                    : $filter('date')(vm.dueDate, 'yyyy-MM-dd HH:mm:ss'),
                invoice_date                : $filter('date')(vm.invoiceDate, 'yyyy-MM-dd HH:mm:ss'),
                currency                    : vm.invoiceCurrency.code,
                items                       : [],
                free_events                 : vm.freeEvents,
                invoiceSource               : vm.invoiceSource,
            };

            angular.forEach(vm.user['additional_services']['items'], function (as) {
                if (as.removed === false) {
                    var seller_key = 'seller_id_' + as.type;
                    var items_fields = {
                        rate        : as.rate,
                        type        : as.type
                    };

                    if (as.seller) {
                        items_fields[seller_key] = as.seller.id;
                    } else {
                        items_fields[seller_key] = null;
                    }

                    fields.items.push(items_fields);
                }
            });

            InvoicesService.validate(fields)
                .then(function(response) {

                    if (response.errors) {
                        vm.formErrors = response.errors;

                        var focusKey = Object.keys(vm.formErrors)[0];
                        vm.focusMe = { [focusKey]: true };

                    } else {

                        vm.query = {};

                        if ($stateParams.hasOwnProperty('expo_id')) {
                            vm.query[vm.invoice_type + '_id'] = $stateParams.expo_id;
                        }

                        InvoicesService.setData(vm);

                        if (vm.invoice_type == 'expo') {
                            $state.go("root.invoices.confirmation");
                        } else {
                            $state.go("root.invoices." + vm.invoice_type + ".confirmation");
                        }
                    }
                })
                .catch(function(err) {
                    console.error(err);
                });

        }

        function getMyErrorValue(var_name, type) {
            var_name = var_name + '_' + type;
            return vm.formErrors[var_name];
        }

        function getMyFocusMeValue(var_name, type) {
            var_name = var_name + '_' + type;
            return vm.focusMe[var_name];
        }

        function checkCredit() {
            // Check max credit
            if ((vm.originalCreditRate * vm.exchangeRate) < vm.creditRate) {
                vm.formErrors['credit_rate'] = ['Credit cannot exceed ' + vm.invoiceCurrency.code + ' ' + parseFloat(vm.originalCreditRate * vm.exchangeRate).toFixed(2)];
                vm.focusMe['credit_rate'];

                vm.validForm = false;

                return false;
            }

            // Check subtotal
            var totalDiscount = parseFloat(vm.discount) +
                parseFloat(vm.discountPlan) +
                parseFloat(vm.discountWebinar) +
                parseFloat(vm.discountEmailBlast);

            if ((parseFloat(vm.creditRate) + totalDiscount) > parseFloat(vm.subtotal)) {
                vm.formErrors['credit_rate'] = ['Credit cannot exceed the Subtotal ' + vm.invoiceCurrency.code + ' ' + parseFloat(vm.subtotal - totalDiscount).toFixed(0)];

                vm.validForm = false;

                return false;
            }

            vm.formErrors['credit_rate'] = '';
            vm.validForm = true;

            return true;
        }

        function setDiscounts() {
            var general = [];
            var virtual_fairs = [];
            var expos = [];

            if (vm.user['general'] != undefined)
                general = $filter('filter')(vm.user['general']['items'], {type: "!miscelaneous"});

            if (vm.user['virtual_fairs'] != undefined)
                virtual_fairs = $filter('filter')(vm.user['virtual_fairs']['items'], {type: "!miscelaneous"});

            if (vm.user['expos'] != undefined) {
                angular.forEach(vm.user['expos'], function (expo) {
                    angular.forEach(expo['items'], function (item) {
                        expos.push(item);
                    });
                });
            }

            var totalItems = expos.length + virtual_fairs.length + general.length;
            var discount_percent = (parseFloat(vm.discount) + parseFloat(vm.creditRate)) / parseFloat(vm.subtotal);


            if (vm.user['virtual_fairs']) {
                angular.forEach(vm.user['virtual_fairs']['items'], function (item) {
                    item.discount = item.type != "miscelaneous" ? parseFloat(parseFloat(item.rate) * parseFloat(discount_percent)).toFixed(2) : 0;
                });
            }

            if (vm.user['general']) {
                angular.forEach(vm.user['general']['items'], function (item) {
                    item.discount = item.type != "miscelaneous" ? parseFloat(parseFloat(item.rate) * parseFloat(discount_percent)).toFixed(2) : 0;
                });
            }

            if (vm.user['expos']) {
                angular.forEach(vm.user['expos'], function (expo) {
                    angular.forEach(expo['items'], function (item) {
                        item.discount = item.type != "miscelaneous" ? parseFloat(parseFloat(item.rate) * parseFloat(discount_percent)).toFixed(2) : 0;
                    });
                });
            }

            vm.updateTotal();
        }

        function freeEventCheck(event)
        {
            vm.discount = 0
            vm.freeEvents.forEach((item, index) => {

                let searchItem = vm.user['virtual_fairs']['items'].filter(vf => vf.virtual_fair_id == index);
                if (item === true) {
                    vm.totalFreeItems--;
                    vm.mis_discount += event.rate
                    if (searchItem.length) {
                        event.discount = event.rate;
                        vm.discount = parseFloat(vm.discount + searchItem[0].rate).toFixed(2);
                        event.app_plan_subscription_id = vm.user['exhibitor']['app_plan']['id'];
                    }
                    vm.sea
                } else {
                    vm.totalFreeItems++;
                    vm.mis_discount -= event.rate
                    if (searchItem.length) {
                        event.discount = 0;
                        vm.discount = parseFloat(vm.discount - searchItem[0].rate).toFixed(2);
                        event.app_plan_subscription_id = 0;
                    }
                }
            })
            vm.setDiscounts()
        }

        function findInvoiceSource() {
            vm.query = {};           
            vm.query['page'] = 1;            
            vm.query['control_id'] = vm.invoiceSource; 

            vm.invoiceSourceData = {};       
            vm.formErrors = [];        
            vm.focusMe = [];
            vm.validForm = true;

            InvoicesService.getInvoicesByFilter(vm.query).then(function(response) {

                vm.invoiceSourceData = response.data.data[0];   
                if (!vm.invoiceSourceData) {
                    vm.invoiceSourceData = false; 
                    vm.invoiceSource = '';
                    vm.formErrors['invoice_source'] = ['Invoice not found: ' + vm.query['control_id']];   
                    vm.validForm = false;                 
                }                

            }).catch(function(err) {
            });
        } 

    }

})();
